import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login"); return; }
    const session_id = match[1];
    // Clear hash from URL
    window.history.replaceState(null, "", window.location.pathname);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data.user);
        const role = data.user?.role;
        navigate(role === "admin" ? "/admin" : role === "vendor" ? "/vendor/dashboard" : "/planner/dashboard", { state: { user: data.user } });
      } catch {
        navigate("/login");
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="eyebrow mb-3">Just a moment</div>
        <div className="font-serif text-3xl">Signing you in…</div>
      </div>
    </div>
  );
}
